import { Box, CircularProgress, styled } from "@mui/material";

export const CMProgress = styled(CircularProgress)(({theme}) => ({
    width: '100%',
    height: '100%',
    animationDuration: '750ms',

    '&.MuiCircularProgress-colorPrimary': {
        color: '#a80000',
    },

    '&.MuiCircularProgress-root': {
        boxShadow: 'inset 0 0 1px 5px gray',
        borderRadius: '50%'
    }

}));

export const CMBox = styled(Box)(({theme}) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}));